import React from 'react'
import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectIsAuthenticated } from '@store/slices/authSlice'
import { ThemeProvider } from '@theme/ThemeProvider'
import { RtlProvider } from '@i18n/RtlProvider'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor } from '@store'
 

// Layout Components
import AppShell from '@layouts/AppShell'

// Pages
import Login from '@pages/Login'
import Dashboard from '@pages/Dashboard'
import Users from '@pages/Users'
import Reminders from '@pages/Reminders'
import Subscriptions from '@pages/Subscriptions'
import Profile from '@pages/Profile'
import Membership from '@pages/Membership'
import Payment from '@pages/Payment'
import PaymentCapture from '@pages/PaymentCapture'
import MembershipCancel from '@pages/MembershipCancel'
import MembershipError from '@pages/MembershipError'
import NotFound from '@pages/NotFound'

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated)

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

// Token Protected Route Component for Membership
const TokenProtectedRoute = ({ children }) => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')

  if (!token) {
    return <Navigate to="/404" replace />
  }

  return children
}


function App() {
  return (
    <PersistGate loading={null} persistor={persistor}>
      <RtlProvider>
        <ThemeProvider>
            <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/membership" element={
              <TokenProtectedRoute>
                <Membership />
              </TokenProtectedRoute>
            } />
            <Route path="/payment" element={<Payment />} />
            <Route path="/payment-capture" element={<PaymentCapture />} />
            <Route path="/membership/cancel" element={<MembershipCancel />} />
            <Route path="/membership/error.html" element={<MembershipError />} />
            <Route path="/404" element={<NotFound />} />

            {/* Protected Routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="users" element={<Users />} />
              <Route path="reminders" element={<Reminders />} />
              <Route path="subscriptions" element={<Subscriptions />} />
              <Route path="profile" element={<Profile />} />
            </Route>

            {/* Catch all route - Global 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ThemeProvider>
      </RtlProvider>
    </PersistGate>
  )
}

export default App
